/**
 * Tahmin etkinliğinin saf hesapları (oyuncu sayfası + panel).
 *
 * Geri sayım **sunucu saatine** göre çizilir: uç her yanıtta `server_time`
 * döndürür ve buradaki fark (`clockSkew`) cihaz saatini düzeltir. Kapanışı
 * zaten sunucu uygular; ama cihaz saati geri kalmış oyuncu ekranda "hâlâ açık"
 * görüp gönderdiğinde reddedilir ve bunu hata sanırdı.
 */

export const PHASE_LABELS = {
  draft: 'Taslak',
  open: 'Tahminler açık',
  closed: 'Sonuç bekleniyor',
  settled: 'Sonuçlandı',
};

export const WIN_RULE_LABELS = {
  exact: 'Tam skor',
  outcome: 'Maç sonucu (1X2)',
};

export const SOCIAL_LABELS = {
  instagram: 'Instagram',
  x: 'X (Twitter)',
  telegram: 'Telegram',
  tiktok: 'TikTok',
  youtube: 'YouTube',
  facebook: 'Facebook',
};

/** Sunucu saati ile cihaz saati arasındaki fark (ms). */
export const clockSkew = (serverTime, now = Date.now()) => {
  const server = new Date(serverTime || 0).getTime();
  if (!serverTime || Number.isNaN(server)) return 0;
  return server - now;
};

/** Kalan sürenin parçaları; süre dolduysa `null`. */
export const splitRemaining = (target, now = Date.now()) => {
  if (!target) return null;
  const diff = new Date(target).getTime() - now;
  if (Number.isNaN(diff) || diff <= 0) return null;
  return {
    days: Math.floor(diff / 86400000),
    hours: Math.floor((diff % 86400000) / 3600000),
    minutes: Math.floor((diff % 3600000) / 60000),
    seconds: Math.floor((diff % 60000) / 1000),
  };
};

/** 1X2 sonucu. */
export const outcomeOf = (home, away) => {
  const h = Number(home);
  const a = Number(away);
  if (h > a) return '1';
  if (h < a) return '2';
  return 'X';
};

const money = (value) => new Intl.NumberFormat('tr-TR', {
  style: 'currency', currency: 'TRY', maximumFractionDigits: 2,
}).format(Number(value || 0));

/** Ödülün oyuncuya söylenen cümlesi; ödül yoksa boş. */
export const rewardText = (event) => {
  const type = event?.reward_type || 'none';
  const amount = Number(event?.reward_amount || 0);
  if (type === 'none' || amount <= 0) return '';
  if (type === 'bonus') {
    const wager = Number(event?.wager_multiplier || 0);
    return wager > 0
      ? `Doğru bilen herkese ${money(amount)} bonus (çevrim ×${wager})`
      : `Doğru bilen herkese ${money(amount)} bonus`;
  }
  return `Doğru bilen herkese ${money(amount)} nakit`;
};

/** Paylaşılacak bağlantı. Taban panelin gönderdiği site köküdür. */
export const eventLink = (base, slug) => {
  const root = String(base || '').replace(/\/+$/, '');
  return slug ? `${root}/etkinlik/${slug}` : '';
};

/** Skor alanı: yalnız 0–99 arası tam sayı; boş bırakılabilir. */
export const clampScore = (value) => {
  if (value === '' || value === null || value === undefined) return '';
  const digits = String(value).replace(/\D/g, '').slice(0, 2);
  return digits === '' ? '' : String(Number(digits));
};
